import { render, staticRenderFns } from "./SolutionsSection.vue?vue&type=template&id=23546610&scoped=true"
import script from "./SolutionsSection.js?vue&type=script&lang=js&external"
export * from "./SolutionsSection.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsSection.scss?vue&type=style&index=0&id=23546610&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23546610",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
